import React, { useState, useEffect } from 'react';
import { generatePlaceholderSVG } from '../utils/placeholderGenerator';
import { realArtworks } from '../data/subjects';

function Familiarization({ artist, onComplete, skipTimer = false }) {
  const [timeRemaining, setTimeRemaining] = useState(40);

  useEffect(() => {
    if (!skipTimer) {
      const timer = setInterval(() => {
        setTimeRemaining(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            onComplete();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [onComplete, skipTimer]);

  // Placeholder images with actual artwork titles and type label
  const getPlaceholderUrl = (index) => {
    const artworks = realArtworks[artist.id] || realArtworks['van-gogh'];
    const title = artworks[index] || `Real ${artist.name} Painting ${index + 1}`;
    const description = `"${title}" by ${artist.name}`;
    const typeLabel = 'REAL PAINTING - FAMILIARIZATION';
    return generatePlaceholderSVG(description, 300, 200, '#4a5568', typeLabel);
  };
  
  const placeholderImages = artist.familiarizationImages || 
    Array.from({length: 6}, (_, i) => getPlaceholderUrl(i));

  return (
    <div className="phase-container">
      <h1>Familiarization: {artist.name}</h1>
      <p>
        To familiarize you with this artist's style, please study the following 
        6 examples of their work. These images will disappear after 40 seconds.
      </p>
      
      <div className="countdown">
        {skipTimer ? 'Navigation Mode - Timer Disabled' : `Time remaining: ${timeRemaining} seconds`}
      </div>
      
      <div className="image-grid">
        {placeholderImages.map((src, index) => (
          <img
            key={index}
            src={src.startsWith('/') ? getPlaceholderUrl(index) : src}
            alt={`${artist.name} example ${index + 1}`}
          />
        ))}
      </div>
      
    </div>
  );
}

export default Familiarization;